import Button from './Button';

const SaveButton = {
    extends : Button,
    props   : {
        text   : { type : String, default : 'Save' },
        icon   : { type : String, default : 'fa fa-save' },
        design : { type : String, default : 'basic' },
        type   : { type : String, default : 'submit' }
    }
};

export default SaveButton;
